module.exports = __webpack_public_path__ + "static/media/quality.ef723936.svg";